import React from 'react';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import CheckIcon from 'material-ui/svg-icons/action/check-circle';

export default ({ showError }) => showError ? (
  <ErrorIcon color="#f44336" style={{ flex: 'none', marginRight: '2px' }} />
) : <CheckIcon color="#4caf50" style={{ flex: 'none', marginRight: '2px' }} />;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/error-check-indicator-icon.jsx